import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'offers'
const verb = 'get'

export default class OspreyOffersSearch extends BaseAction {
    constructor(dataKey) {
        const id = 'fdd6bf2b-3340-43ed-ba20-4a60c9d0d5f6'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    search(params) {
        this.params = Object.assign({
            fields: 'archived,content,created,description,expiration,id,language,marketingCategory,modified,name,offers,ownerOrn,shareTo,status,tags',
            archived: false
        }, params)

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-search.js